import { pushDataLayer } from '@scripts/utils';
import Alpine from 'alpinejs';

Alpine.data('upsellProducts', () => ({
  async addToCart() {
    this.$el.disabled = 'true';
    const counter = this.$el.previousElementSibling;
    const quantity = counter ? counter.dataset.count : 1;
    const variantId = this.$el.dataset.productId;
    const { position } = this.$el.dataset;
    const journey = this.$root?.dataset?.journey;
    const items = [
      {
        id: variantId,
        quantity,
      },
    ];

    // recommendation analytics
    pushDataLayer({ event: 'recommendation_click', variantId, position, journey });

    try {
      await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      pushDataLayer({ event: 'recommendation_add_to_cart', variantId, position, journey });

      // Adding a past paper can flip the cart banners (cross-sell <-> upsell) and
      // changes totals/discount tiers, which a partial DOM swap can't represent.
      // Reload to re-render the whole cart consistently.
      window.location.reload();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error({ error });
      this.$el.disabled = 'false';
    }
  },
}));
